export default {
  type: 'login',
  extra: {
    authorization: false,
    platformHandler: false
  },
  path: ['/login'],
  handler(info) {
    return new Promise((resolve, reject) => {
      const { to, from, next } = info
      console.log(to.path, to.query, this.type)
      if (!to.query.from && from.path !== '/privacyTreaty') {
        resolve({
          ...to,
          query: {
            from: from.path === '/' ? undefined : from.path.replace('/', ''),
            ...from.query,
            ...to.query
          }
        })
      } else {
        resolve()
      }
    })
  }
}
